<template>
  <div class="tabbar">
    <div class="line">
      <div class="tab-list">
        <div
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="index"
          :class="tabIndex == index ? 'tab-active' : ''"
          @click="handleTab(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    playerList: {
      type: Array,
      defalut: () => [],
    },
  },
  components: {},
  data() {
    return {
      tabIndex: 0,
      tabList: [
        {
          name: '赛事主页',
        },
        {
          name: '赛程',
        },
        {
          name: '奖牌榜',
        },
        {
          name: '球队榜',
        },
        {
          name: '球员榜  ',
        },
      ],
      matchIndex: 0,
      playerDetai: false,
      matchList: [
        {
          id: 1,
          name: '全部',
        },
        {
          id: 2,
          name: '短跑',
        },
        {
          id: 1,
          name: '中长跑',
        },
        {
          id: 1,
          name: '跨栏',
        },
        {
          id: 1,
          name: '接力赛',
        },
        {
          id: 1,
          name: '马拉松',
        },
        {
          id: 1,
          name: '竞走',
        },
        {
          id: 1,
          name: '跳跃',
        },
        {
          id: 1,
          name: '投掷',
        },
        {
          id: 1,
          name: '全能',
        },
      ],
      component: 'VolleyballInfo',
    }
  },
  methods: {
    handleTab(item, index) {
      this.tabIndex = index
      switch (this.tabIndex) {
        case 0:
          this.component = 'VolleyballInfo'
          break
        case 1:
          // this.component='VolleyballSchedule'
          this.component = 'MatchVolleyballSchedule'
          break
        case 2:
          this.component = 'VolleyballRank'
          break
        case 3:
          this.component = 'VolleyballTeam'
          break
        case 4:
          this.component = 'VolleyballPlayer'
          break
        default:
          this.component = 'VolleyballInfo'
      }
      this.$emit('setComponent', this.component)
    },
  },
}
</script>

<style lang="scss" scoped>
.tabbar {
  width: 100%;
  padding-top: 10px;
  // 导航列表
  .line {
    border-bottom: 1px solid #e1e1e1;
    .tab-list {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #000000;
      .tab-item {
        width: 120px;
        height: 50px;
        line-height: 50px;
        border-radius: 20px 20px 0 0;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;
        font-size: 18px;
      }
    }
    .tab-active {
      background-color: #aa1f23;
      color: #ffffff;
      font-size: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/volleyball/components/VolleyballMatchTabbar.vue